<template>
  <div class="container content">

    <div v-if="shared">
      <SharedHeader />
    </div>

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              MFQA 1
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">
      <div class=" card-header">
        <div class="card-header-title">
          Property Information
        </div>
        <div
          v-if="!shared"
          class="level-right is-small"
        >
          <a
            @click="goToProperty()"
            style="padding-left: 20px"
          >
            <i class="fas fa-arrow-left"></i>
            return to property</a>
          &nbsp;&nbsp;

          <button
            v-if="!shared"
            class="button is-small is-primary"
            @click="shareEvaluation($store.state.bpo)"
          ><i class="fas fa-link"></i>&nbsp;&nbsp;Share MFQA 1</button>
          &nbsp;&nbsp;
        </div>
      </div>
      <div class="card-content">

        <div class="columns">

          <div class="column">

            <div v-if="$store.state.property.multifamilyAttributes.propertyName">
              <h2>{{ $store.state.property.multifamilyAttributes.propertyName }}</h2>
              <h4>{{ $store.state.property.address }}</h4>
              <h4>{{ $store.state.property.city }}, {{ $store.state.property.state }} {{ $store.state.property.zip }}</h4>
            </div>
            <div v-if="!$store.state.property.multifamilyAttributes.propertyName">
              <h3>{{ $store.state.property.address }}</h3>
              <h4>{{ $store.state.property.city }}, {{ $store.state.property.state }} {{ $store.state.property.zip }}</h4>
            </div>
          </div>

          <div class="column">
            <div class="content"></div>
            <div class="level">
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Units</p>
                  <p class="subtitle">&nbsp;{{ $store.state.property.multifamilyAttributes.units }}&nbsp;</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Year Built</p>
                  <p class="subtitle">&nbsp;{{ $store.state.property.multifamilyAttributes.yearBuilt }}&nbsp;</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Class</p>
                  <p class="subtitle">&nbsp;{{ $store.state.property.multifamilyAttributes.propertyClass }}&nbsp;</p>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="card">
      <section class="hero is-info">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Worksheet
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">

      <div class="card-content">

        <div v-if="shared && readonly">
          <b-message
            type="is-info"
            has-icon
          >
            <div class="subtitle">View Only - this shared evaluation is in view-only mode, changes are not allowed.</div>
          </b-message>
          <p></p>
        </div>

        <div v-if="shared && !readonly">
          <b-message
            type="is-info"
            has-icon
          >
            <div class="subtitle">Edit - this shared evaluation is in edit mode, any changes you make will update the evaluation for everyone.</div>
          </b-message>
          <p></p>
        </div>

        <!-- SPREADSHEET TRIAL 1 -->

        <div class="tile is-ancestor is-size-7">
          <div class="tile is-6 is-vertical is-parent">
            <div class="tile is-child box">
              <!-- TOP LEFT -->
              <p class="title">Deal Terms</p>

              <table class="table is-fullwidth">

                <tr>
                  <td
                    colspan="3"
                    style="border: none !important;"
                  >
                  </td>
                </tr>

                <tr>

                  <td>
                    Asking Price
                    <b-tooltip
                      type="is-info"
                      label="The price the seller is asking for. This isn't used in any calculations so you can leave it blank, but it's nice to have for informational purposes."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right;"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.askingPrice_E17"
                        @input="calculate('inputs.askingPrice_E17')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td class="align-right">{{ $store.state.bpo.outputs.askingPricePerUnit_F17 | currency(0) }} per unit</td>

                </tr>

                <tr>

                  <td>Offer Price
                    <b-tooltip
                      type="is-info"
                      label="The price you will offer to purchase the property. The Cap Rate % option will calculate an offer price based on a Cap Rate. The Cap Rate is asset class specific -- a Mentor, Broker, or Seller may provide this to you. The proforma year 1 Net ROI is the percentage of ROI based on your cash invested. The proforma year 1 DSCR (Debt Service Coverage Ratio) is the ratio of cash available to debt servicing for interest, principal and lease payments."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="align-right">{{ $store.state.bpo.outputs.offerPrice_E18 | currency(0) }}</div>

                    <div style="padding-top: 1em">

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.offerPriceCalcType"
                          native-value="Raw"
                          @input="calculate('inputs.offerPriceCalcType')"
                          :disabled="readonly"
                        >
                          Actual offer price
                        </b-radio>

                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.offerPriceCalcType != 'Raw'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.offerPriceCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.offerPrice_E18"
                            @input="calculate('inputs.offerPrice_E18')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.offerPriceCalcType"
                          native-value="CapRate"
                          @input="calculate('inputs.offerPriceCalcType')"
                          :disabled="readonly"
                        >
                          Calculate based on actual Cap Rate
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.offerPriceCalcType != 'CapRate'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ $store.state.bpo.inputs.offerPriceCalcType != 'CapRate' ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.offerPriceCapRate"
                            @input="calculate('inputs.offerPriceCapRate')"
                            :options="percentage"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.offerPriceCalcType"
                          native-value="Dscr"
                          @input="calculate('inputs.offerPriceCalcType')"
                          :disabled="readonly"
                        >
                          Calculate based on proforma Debt Service Coverage Ratio (DSCR)
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.offerPriceCalcType != 'Dscr'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ $store.state.bpo.inputs.offerPriceCalcType != 'Dscr' ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.offerPriceTargetDebtServiceCoverageRatio"
                            @input="calculate('inputs.offerPriceTargetDebtServiceCoverageRatio')"
                            :options="decimal"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.offerPriceCalcType"
                          native-value="NetRoi"
                          @input="calculate('inputs.offerPriceCalcType')"
                          :disabled="readonly"
                        >
                          Calculate based on proforma Net ROI
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.offerPriceCalcType != 'NetRoi'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ $store.state.bpo.inputs.offerPriceCalcType != 'NetRoi' ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.offerPriceTargetNetReturnOnInvestment"
                            @input="calculate('inputs.offerPriceTargetNetReturnOnInvestment')"
                            :options="percentage"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                    </div>

                  </td>

                  <td class="align-right">{{ $store.state.bpo.outputs.offerPricePerUnit_F18 | currency(0) }} per unit</td>

                </tr>

                <tr>

                  <td>Rehab - In Loan</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.rehabInLoan_E19 | currency(0) }}</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.rehabInLoanPerUnit_F19 | currency(0) }} per unit</td>

                </tr>

                <tr>

                  <td>Total "In"</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.totalIn_E20 | currency(0) }}</td>

                  <td></td>

                </tr>

                <tr>

                  <td>Closing Costs
                    <b-tooltip
                      type="is-info"
                      label="The percentage of the Total In amount that will be used for the costs of closing the deal. A conservative place to start is 6%."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td style="text-align: right;">
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.closingCostPercent_D21"
                        @input="calculate('inputs.closingCostPercent_D21')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td class="align-right">{{ $store.state.bpo.outputs.closingCost_E21 | currency(0) }}</td>

                </tr>

                <tr>

                  <td>Operating Capital
                    <b-tooltip
                      type="is-info"
                      label="Amount set aside for initial Operating Capital expenses. Guideline is MINIMUM 1 month expense and debt service. Recommended amount is 2 months expense and debt service. If you turn on Calculate then 2 months will be calculated automatically."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>

                  </td>

                  <td>
                    <div class="align-right">{{ $store.state.bpo.outputs.operatingCapital_E22 | currency(0) }}</div>

                    <div style="padding-top: 1em">

                      <span>

                        <b-radio
                          v-model="$store.state.bpo.inputs.operatingCapitalCalcType"
                          native-value="Raw"
                          @input="calculate('inputs.operatingCapitalCalcType')"
                          :disabled="readonly"
                        >
                          Actual operating capital
                        </b-radio>

                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.operatingCapitalCalcType != 'Raw'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.operatingCapitalCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.operatingCapital_E22"
                            @input="calculate('inputs.operatingCapital_E22')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>

                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.operatingCapitalCalcType"
                          native-value="Calculated"
                          @input="calculate('inputs.operatingCapitalCalcType')"
                          :disabled="readonly"
                        >
                          Calculate based on 2 months expenses
                        </b-radio>

                      </span>

                    </div>

                  </td>

                  <td></td>

                </tr>

                <tr>

                  <td>Rehab - Not In Loan</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.rehabNotInLoan_E23 | currency(0) }}</td>

                  <td></td>

                </tr>

                <tr>

                  <td>Total Out Of Pocket</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.totalOutOfPocket_E24 | currency(0) }}</td>

                  <td></td>

                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>

                  <td>#/Units</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.numberOfUnits_E26 }}</td>

                  <td></td>

                </tr>

                <tr>

                  <td>Total "In"$/Unit</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.totalInPricePerUnit_E27 | currency(0) }}</td>

                  <td></td>

                </tr>

                <tr>

                  <td>Down Payment
                    <b-tooltip
                      type="is-info"
                      label="Percentage of the Total In amount that estimates the down payment. Usually around 20% to 40%."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.downPaymentPercent_E28"
                        @input="calculate('inputs.downPaymentPercent_E28')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td class="align-right">{{ $store.state.bpo.outputs.downPayment_F28 | currency(0) }}</td>

                </tr>

                <tr>

                  <td>Loan Amount</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.loanAmount_E29 | currency(0) }}</td>

                  <td></td>

                </tr>

                <tr>

                  <td>Interest Rate
                    <b-tooltip
                      type="is-info"
                      label="The interest rate of the loan."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.interestRatePercent_E30"
                        @input="calculate('inputs.interestRatePercent_E30')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td></td>

                </tr>

                <tr>

                  <td>Years Amortization
                    <b-tooltip
                      type="is-info"
                      label="How many years the loan is for."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.termInYears_E31"
                        @input="calculate('inputs.termInYears_E31')"
                        :options="years"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td></td>

                </tr>

                <tr>

                  <td>Interest Only?
                    <b-tooltip
                      type="is-info"
                      label="If the loan is interest only then turn this on"
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">

                      <select
                        class="select is-small"
                        placeholder=""
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.interestOnly"
                        @input="calculate('inputs.interestOnly')"
                        :disabled="readonly"
                      >
                        <option :value="false">No</option>
                        <option :value="true">Yes</option>
                      </select>

                    </div>
                  </td>

                  <td></td>

                </tr>

                <tr>

                  <td>Annual Debt Service (P&I)</td>

                  <td class="align-right">{{ $store.state.bpo.outputs.annualDebtService_E32 | currency(0) }}</td>

                  <td></td>

                </tr>

                <tr>

                  <td>Total Rehab
                    <b-tooltip
                      type="is-info"
                      label="Estimate of how much the rehab will cost. Take the # of units times a dollar per unit amount. Recommended starting point is $3000 per unit. The condition of the property determines the $/unit. Poorer conditions, use a higher value. Better conditions use a lower value."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="align-right">{{ $store.state.bpo.outputs.totalRehab_E33 | currency(0) }}</div>

                    <span>
                      <b-radio
                        v-model="$store.state.bpo.inputs.totalRehabCalcType"
                        native-value="Raw"
                        @input="calculate('inputs.totalRehabCalcType')"
                        :disabled="readonly"
                      >
                        Actual total rehab
                      </b-radio>

                      <div class="level-right">
                        <vue-autonumeric
                          :disabled="$store.state.bpo.inputs.totalRehabCalcType != 'Raw'"
                          class="input is-small"
                          style="text-align: right"
                          v-bind:style="[ ($store.state.bpo.inputs.totalRehabCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                          v-model="$store.state.bpo.inputs.totalRehab_E33"
                          @input="calculate('inputs.totalRehab_E33')"
                          :options="currency"
                          :readonly="readonly"
                        />
                      </div>
                    </span>

                    <span>
                      <b-radio
                        v-model="$store.state.bpo.inputs.totalRehabCalcType"
                        native-value="UnitFactor"
                        @input="calculate('inputs.totalRehabCalcType')"
                        :disabled="readonly"
                      >
                        Calculate based on $ per Unit
                      </b-radio>
                      <div class="level-right">
                        <vue-autonumeric
                          :disabled="$store.state.bpo.inputs.totalRehabCalcType != 'UnitFactor'"
                          class="input is-small"
                          style="text-align: right"
                          v-bind:style="[ ($store.state.bpo.inputs.totalRehabCalcType != 'UnitFactor') ? {} : { backgroundColor: inputBackgroundColor }]"
                          v-model="$store.state.bpo.inputs.totalRehabUnitFactor"
                          @input="calculate('inputs.totalRehabUnitFactor')"
                          :options="currency"
                          :readonly="readonly"
                        />
                      </div>
                    </span>
                  </td>

                  <td></td>

                </tr>

                <tr>

                  <td>% of Rehab to be Financed
                    <b-tooltip
                      type="is-info"
                      label="The percentage of the rehab that will be financed with borrowed money."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.percentOfRehabToBeFinanced_E34"
                        @input="calculate('inputs.percentOfRehabToBeFinanced_E34')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td></td>

                </tr>

              </table>

            </div>

            <div class="tile is-child box">
              <!-- BOTTOM LEFT -->

              <p class="title">Rents</p>

              <div class="level">

                <button
                  class="button is-primary is-small"
                  @click="addLine"
                  :disabled="readonly"
                >Add Rent</button>

                <div>
                  <b-field>
                    <vue-autonumeric
                      class="input is-small"
                      style="text-align: right; width: 4em"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="$store.state.bpo.inputs.proformas.rentIncreasePercent_O26"
                      @input="calculate('inputs.proformas.rentIncreasePercent_O26')"
                      :options="percentage"
                      :readonly="readonly"
                    />
                    <p class="control">
                      <span
                        class="button is-primary is-small"
                        @click="updateRentIncreasePercent()"
                        :disabled="readonly"
                      >Increase Rent</span>
                    </p>
                  </b-field>
                </div>

                <div class="level">
                  <button
                    class="button is-info is-small"
                    @click="showRentRangeComps()"
                    :disabled="readonly"
                  >Get Scheduled Rents from RentRange</button>
                  <b-tooltip
                    style="margin-left: 0.4em"
                    type="is-info"
                    label="Quickly set the Scheduled Rent $ column by looking up market rents on RentRange. This is a valid option when you are doing a 'back of the napkin' calculation. You can replace these values later after you do a deeper market survey."
                    multilined
                  >
                    <i class="far fa-question-circle fa-lg"></i>
                  </b-tooltip>
                </div>

              </div>

              <section
                class="section"
                v-if="$store.state.bpo.inputs.rents.length == 0"
              >
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="emoticon-happy"
                      size="is-large"
                    >
                    </b-icon>
                  </p>
                  <p>No rents yet, please add them</p>
                </div>
              </section>

              <table class="table is-fullwidth">

                <tr>
                  <th style="vertical-align: bottom; text-align: left">Type</th>
                  <th style="vertical-align: bottom; text-align: right">#</th>
                  <th style="vertical-align: bottom; text-align: right">Sqft</th>
                  <th style="vertical-align: bottom; text-align: right">Scheduled Rent $</th>
                  <th style="vertical-align: bottom; text-align: right">Proforma Rent $</th>
                  <th></th>
                  <th></th>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo.inputs.rents"
                  v-bind:key="index"
                  class="row"
                >

                  <td>
                    <select
                      class="select is-small"
                      placeholder=""
                      v-model="line.type"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      @input="calculate('inputs.rents')"
                      :disabled="readonly"
                    >
                      <option
                        v-for="unitType in $store.state.bpoUnitTypes"
                        :value="unitType"
                        :key="unitType"
                      >
                        {{ unitType }}
                      </option>
                    </select>
                  </td>

                  <td>
                    <vue-autonumeric
                      class="input is-small"
                      style="text-align: right"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="line.unitCount"
                      @input="calculate('inputs.rents')"
                      :options="number"
                      :readonly="readonly"
                    />
                  </td>

                  <td>
                    <vue-autonumeric
                      class="input is-small"
                      style="text-align: right"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="line.sqft"
                      @input="calculate('inputs.rents')"
                      :options="number"
                      :readonly="readonly"
                    />
                  </td>

                  <td>
                    <vue-autonumeric
                      class="input is-small"
                      style="text-align: right"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="line.currentRent"
                      @input="calculate('inputs.rents')"
                      :options="currency"
                      :readonly="readonly"
                    />
                  </td>

                  <td>
                    <vue-autonumeric
                      class="input is-small"
                      style="text-align: right"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="line.proformaRent"
                      @blur="updateProformaGrossRentalIncome()"
                      @input="calculate('inputs.rents')"
                      :options="currency"
                      :readonly="readonly"
                    />
                  </td>

                  <td style="padding-left: 0px;padding-right: 0px">
                    <button
                      class="button is-small"
                      @click="addLine(index)"
                      round
                      :disabled="readonly"
                    ><i class="fas fa-plus"></i></button>
                  </td>

                  <td style="padding-left: 0px;padding-right: 0px">
                    <button
                      class="button is-small"
                      @click="removeLine(index)"
                      round
                      :disabled="readonly"
                    ><i class="fas fa-trash"></i></button>
                  </td>

                </tr>

              </table>

              <p class="subtitle">Scheduled Rent Grid</p>

              <table class="table is-fullwidth">
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Mthly</td>
                  <td class="header align-center">Annual</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo.outputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.currentRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft | number(0) }}</td>
                  <td class="align-center">{{ line.currentPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.currentMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.currentAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalUnitCount_J19 }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentRent_K19 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalSqft_L19 | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentPricePerSqft_M19 | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentMonthly_N19 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentAnnual_O19 | currency(0) }}</td>
                </tr>

              </table>

              <p class="subtitle">Proforma Rent Grid</p>

              <table class="table is-fullwidth">
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Mthly</td>
                  <td class="header align-center">Annual</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo.outputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.proformaRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft }}</td>
                  <td class="align-center">{{ line.proformaPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.proformaMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.proformaAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalUnitCount_J19 }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaRent_K37 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalSqft_L19 | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaPricePerSqft_M37 | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaMonthly_N37 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaAnnual_O37 | currency(0) }}</td>
                </tr>

              </table>

            </div>

            <div class="tile is-child box">
              <p class="title">Notes</p>

              <div>
                <vue-editor
                  :editorToolbar="customToolbar"
                  v-model="$store.state.bpo.inputs.notes_I45"
                  @input="calculate('inputs.notes_I45')"
                  :disabled="readonly"
                ></vue-editor>
              </div>

            </div>

          </div>

          <div class="tile is-parent">

            <div class="tile is-child box">
              <!-- RIGHT SIDE -->

              <p class="title">Summary Projection</p>

              <table class="table is-fullwidth">

                <tr>
                  <td></td>

                  <td>
                    <input
                      type="text"
                      class="input is-small"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="$store.state.bpo.inputs.actuals.label_E36"
                      @focus="$event.target.select()"
                      @input="calculate('inputs.actuals.label_E36')"
                      :readonly="readonly"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      class="input is-small"
                      v-bind:style="{ backgroundColor: inputBackgroundColor }"
                      v-model="$store.state.bpo.inputs.brokers.label_F36"
                      @focus="$event.target.select()"
                      @input="calculate('inputs.brokers.label_F36')"
                      :readonly="readonly"
                    />
                  </td>

                  <td class="align-right column-header">Proforma</td>
                </tr>

                <tr>
                  <td>Gross Rental Income
                    <b-tooltip
                      type="is-info"
                      label="The gross annual revenue from all of the rents for all of the units. Does not take into account vacancies and bad debt."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>

                    <div class="align-right">{{ $store.state.bpo.outputs.actuals.grossRentalIncome_E38 | currency(0) }}</div>

                    <div style="padding-top: 1em">
                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.actuals.grossRentalIncomeCalcType"
                          native-value="Raw"
                          @input="calculate('inputs.actuals.grossRentalIncomeCalcType')"
                          :disabled="readonly"
                        >
                          Actual gross rental income
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.actuals.grossRentalIncomeCalcType != 'Raw'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.actuals.grossRentalIncomeCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.actuals.grossRentalIncome_E38"
                            @input="calculate('inputs.actuals.grossRentalIncome_E38')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.actuals.grossRentalIncomeCalcType"
                          native-value="Calculated"
                          @input="calculate('inputs.actuals.grossRentalIncomeCalcType')"
                          :disabled="readonly"
                        >
                          Use Scheduled Rent
                        </b-radio>

                      </span>
                    </div>

                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.grossRentalIncome_F38"
                        @input="calculate('inputs.brokers.grossRentalIncome_F38')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>

                    <div class="align-right">{{ $store.state.bpo.outputs.proformas.grossRentalIncome_G38 | currency(0) }}</div>

                    <div style="padding-top: 1em">

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.proformas.grossRentalIncomeCalcType"
                          native-value="Raw"
                          @input="calculate('inputs.proformas.grossRentalIncomeCalcType')"
                          :disabled="readonly"
                        >
                          Proforma gross rental income
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.proformas.grossRentalIncomeCalcType != 'Raw'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.proformas.grossRentalIncomeCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.proformas.grossRentalIncome_G38"
                            @input="calculate('inputs.proformas.grossRentalIncome_G38')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.proformas.grossRentalIncomeCalcType"
                          native-value="Calculated"
                          @input="calculate('inputs.proformas.grossRentalIncomeCalcType')"
                          :disabled="readonly"
                        >
                          Use Proforma Rent
                        </b-radio>

                      </span>

                    </div>

                  </td>
                </tr>

                <tr>
                  <td>Economic Vacancy Rate %
                    <b-tooltip
                      type="is-info"
                      label="The percentage of vacancy expected. It's recommended for the Actual column that you enter the Effective Rent Income (how much rent has been collected at the property in the last 12 months). The Economic Vacany Rate % is derived from this formula: annual effective rental income / annual scheduled rent income."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="align-right">{{ $store.state.bpo.outputs.actuals.economicVacancyRate_K41 | percent(1) }}</div>

                    <div style="padding-top: 1em">
                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.actuals.economicVacanycRateCalcType"
                          native-value="Raw"
                          @input="calculate('inputs.actuals.economicVacanycRateCalcType')"
                          :disabled="readonly"
                        >
                          Actual economic vacancy rate
                        </b-radio>

                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.actuals.economicVacanycRateCalcType != 'Raw'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.actuals.economicVacanycRateCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.actuals.economicVacancyRate_K41"
                            @input="calculate('inputs.actuals.economicVacancyRate_K41')"
                            :options="percentage"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.actuals.economicVacanycRateCalcType"
                          native-value="EffectiveRentalIncome"
                          @input="calculate('inputs.actuals.economicVacanycRateCalcType')"
                          :disabled="readonly"
                        >
                          Calculate based on Effective Rent Income
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.actuals.economicVacanycRateCalcType != 'EffectiveRentalIncome'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.actuals.economicVacanycRateCalcType != 'EffectiveRentalIncome') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.actuals.effectiveRentalIncome"
                            @input="calculate('inputs.actuals.effectiveRentalIncome')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.economicVacancyRate_K42"
                        @input="calculate('inputs.brokers.economicVacancyRate_K42')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.economicVacancyRate_K43"
                        @input="calculate('inputs.proformas.economicVacancyRate_K43')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>Economic Vacancy</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.economicVacancy_E39 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.economicVacancy_F39 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.economicVacancy_G39 | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td>Net Rental Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netRentalIncome_E40 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netRentalIncome_F40 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netRentalIncome_G40 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Laundry
                    <b-tooltip
                      type="is-info"
                      label="Revenue generated by onsite laundry services, if the property has it."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.actuals.laundry_E42"
                        @input="calculate('inputs.actuals.laundry_E42')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.laundry_F42"
                        @input="calculate('inputs.brokers.laundry_F42')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.laundry_G42"
                        @input="calculate('inputs.proformas.laundry_G42')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>RUBS
                    <b-tooltip
                      type="is-info"
                      label="(Ratio Utility Billing System) Revenue generated from charging tenants for utilities based on sqft and/or number of people living in unit."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.actuals.rubs"
                        @input="calculate('inputs.actuals.rubs')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.rubs"
                        @input="calculate('inputs.brokers.rubs')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.rubs"
                        @input="calculate('inputs.proformas.rubs')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>Misc. Other Income
                    <b-tooltip
                      type="is-info"
                      label="Revenue generated by sources other than rent and laundry."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.actuals.miscellaneousOtherIncome_E43"
                        @input="calculate('inputs.actuals.miscellaneousOtherIncome_E43')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.miscellaneousOtherIncome_F43"
                        @input="calculate('inputs.brokers.miscellaneousOtherIncome_F43')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.miscellaneousOtherIncome_G43"
                        @input="calculate('inputs.proformas.miscellaneousOtherIncome_G43')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Total Net Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.totalNetIncome_E45 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.totalNetIncome_F45 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.totalNetIncome_G45 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Expenses per Unit
                    <b-tooltip
                      type="is-info"
                      label="Derived from operating expenses / # of units. Suggest starting at $3,000 per unit which will get a roof and basic paint job. We almost always use this number on a Quick Analysis before seeing the property."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                    <button
                      class="button is-info is-small"
                      @click="showExpenseGuidelines = !showExpenseGuidelines"
                    >Show Guidelines</button>
                    <b-message
                      class="is-size-7"
                      :active.sync="showExpenseGuidelines"
                    >
                      <table>
                        <tr>
                          <th>
                            <p class="has-text-weight-semibold">Units</p>
                          </th>
                          <th>
                            <p class="has-text-weight-semibold">Expense</p>
                          </th>
                        </tr>
                        <tr>
                          <td nowrap>1-20</td>
                          <td>$2,750</td>
                        </tr>
                        <tr>
                          <td nowrap>21-39</td>
                          <td>$3,000</td>
                        </tr>
                        <tr>
                          <td nowrap>40-59</td>
                          <td>$3,250</td>
                        </tr>
                        <tr>
                          <td nowrap>50-79</td>
                          <td>$3,500</td>
                        </tr>
                        <tr>
                          <td nowrap>80-99</td>
                          <td>$3,750</td>
                        </tr>
                        <tr>
                          <td nowrap>100-124</td>
                          <td>$4,000</td>
                        </tr>
                        <tr>
                          <td nowrap>125-150</td>
                          <td>$4,250</td>
                        </tr>
                        <tr>
                          <td nowrap>150-174</td>
                          <td>$4,500</td>
                        </tr>
                        <tr>
                          <td nowrap>275-299</td>
                          <td>$4,750</td>
                        </tr>
                        <tr>
                          <td nowrap>200+</td>
                          <td>$5,000</td>
                        </tr>
                        <tr>
                          <td colspan="2">Add $1000 for ABP</td>
                        </tr>
                      </table>
                    </b-message>
                  </td>

                  <td>
                    <div class="align-right">{{ $store.state.bpo.outputs.actuals.expensesPerUnit_E47 | currency(0) }}</div>

                    <div style="padding-top: 1em">

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.actuals.expensesPerUnitCalcType"
                          native-value="Raw"
                          @input="calculate('inputs.actuals.expensesPerUnitCalcType')"
                          :disabled="readonly"
                        >
                          Actual expenses per unit
                        </b-radio>

                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.actuals.expensesPerUnitCalcType != 'Raw'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.actuals.expensesPerUnitCalcType != 'Raw') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.actuals.expensesPerUnit_E47"
                            @input="calculate('inputs.actuals.expensesPerUnit_E47')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                      <span>
                        <b-radio
                          v-model="$store.state.bpo.inputs.actuals.expensesPerUnitCalcType"
                          native-value="OperatingExpenses"
                          @input="calculate('inputs.actuals.expensesPerUnitCalcType')"
                          :disabled="readonly"
                        >
                          Calculate based on T12 Operating Expenses
                        </b-radio>
                        <div class="level-right">
                          <vue-autonumeric
                            :disabled="$store.state.bpo.inputs.actuals.expensesPerUnitCalcType != 'OperatingExpenses'"
                            class="input is-small"
                            style="text-align: right"
                            v-bind:style="[ ($store.state.bpo.inputs.actuals.expensesPerUnitCalcType != 'OperatingExpenses') ? {} : { backgroundColor: inputBackgroundColor }]"
                            v-model="$store.state.bpo.inputs.actuals.t12OperatingExpenses"
                            @input="calculate('inputs.actuals.t12OperatingExpenses')"
                            :options="currency"
                            :readonly="readonly"
                          />
                        </div>
                      </span>

                    </div>

                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.expensesPerUnit_F47"
                        @input="calculate('inputs.brokers.expensesPerUnit_F47')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.expensesPerUnit_G47"
                        @input="calculate('inputs.proformas.expensesPerUnit_G47')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>Expenses per Sqft</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.expensesPerSqft_E48 | currency(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.expensesPerSqft_F48 | currency(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.expensesPerSqft_G48 | currency(2) }}</td>
                </tr>

                <tr>
                  <td>Expenses as % of Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.expensesAsPercentOfIncome_E49 | percent(1) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.expensesAsPercentOfIncome_F49 | percent(1) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.expensesAsPercentOfIncome_G49 | percent(1) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Total Expenses</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.totalExpenses_E51 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.totalExpenses_F51 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.totalExpenses_G51 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>Net Operating Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netOperatingIncome_E53 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netOperatingIncome_F53 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netOperatingIncome_G53 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Mortgage Interest</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.mortgageInterest_E55 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.mortgageInterest_F55 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.mortgageInterest_G55 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Capital Reserves per Unit
                    <b-tooltip
                      type="is-info"
                      label="Funds set aside to cover future capital costs so they don't come out of cash flow."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.actuals.capitalReservesPerUnit_E57"
                        @input="calculate('inputs.actuals.capitalReservesPerUnit_E57')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.capitalReservesPerUnit_F57"
                        @input="calculate('inputs.brokers.capitalReservesPerUnit_F57')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.capitalReservesPerUnit_G57"
                        @input="calculate('inputs.proformas.capitalReservesPerUnit_G57')"
                        :options="currency"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>Capital Reserves</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.capitalReserves_E58 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.capitalReserves_F58 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.capitalReserves_G58 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Pre-Tax Profit</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.preTaxProfit_E60 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.preTaxProfit_F60 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.preTaxProfit_G60 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Pre-Tax ROI</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.preTaxROI_E61 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.preTaxROI_F61 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.preTaxROI_G61 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Asset Management
                    <b-tooltip
                      type="is-info"
                      label="Set to 0% if you are an independent owner. If you are a lead then the max fee per the Whitepaper you can charge for asset and property management is 5%. It is recommended to have 3% included above the ROI in the expenses, and 2% included here which will be below the ROI line."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                    <div
                      class="level-left"
                      style="margin-left: 4em"
                    >
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right; width: 4em"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.assetManagementPercent_D63"
                        @input="calculate('inputs.assetManagementPercent_D63')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.assetManagement_F63 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.assetManagement_G63 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Principal Reduction</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.principalReduction_E64 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.principalReduction_F64 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.principalReduction_G64 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Debt Service</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.debtService_E65 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.debtService_F65 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.debtService_G65 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Debt Service Coverage Ratio</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.debtServiceCoverageRatio_E66 | number(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.debtServiceCoverageRatio_F66 | number(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.debtServiceCoverageRatio_G66 | number(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net Cash Flow (Annual)</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netCashflowAnnual_E68 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netCashflowAnnual_F68 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netCashflowAnnual_G68 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net ROI (Cash-on-Cash)</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netROICashOnCash_E70 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netROICashOnCash_F70 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netROICashOnCash_G70 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Lead Investor Compensation
                    <b-tooltip
                      type="is-info"
                      label="If you are an independent owner, leave this 0%. For leads and per the Whitepaper, a 1st time lead can charge 5%, a 2nd time lead can charge 10%, and a 3rd time or more lead can charge 15%."
                      multilined
                    >
                      <i class="far fa-question-circle fa-lg"></i>
                    </b-tooltip>
                    <div
                      class="level-left"
                      style="margin-left: 4em"
                    >
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right; width: 4em"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.leadInvestorCompensationPercent_D72"
                        @input="calculate('inputs.leadInvestorCompensationPercent_D72')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>
                  <td class="
                        align-right">
                  </td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.leadInvestorCompensation_F72 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.leadInvestorCompensation_G72 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Net to Passives</td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netToPassives_F73 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netToPassives_G73 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Net ROI to Passives</td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netROIToPassives_F74 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netROIToPassives_G74 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>
                    <div class="level">
                      CAP RATE PROJECTION
                      <b-tooltip
                        type="is-info"
                        label="Estimated rate of return for this investment. A Mentor or Broker will help you with this rate since it's market and asset class dependent."
                        multilined
                      >
                        <i class="far fa-question-circle fa-lg"></i>
                      </b-tooltip>
                    </div>
                  </td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.capRateProjection_E76 | percent(2) }}</td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.brokers.capRateProjection_F76"
                        @input="calculate('inputs.brokers.capRateProjection_F76')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                  <td>
                    <div class="level-right">
                      <vue-autonumeric
                        class="input is-small"
                        style="text-align: right"
                        v-bind:style="{ backgroundColor: inputBackgroundColor }"
                        v-model="$store.state.bpo.inputs.proformas.capRateProjection_G76"
                        @input="calculate('inputs.proformas.capRateProjection_G76')"
                        :options="percentage"
                        :readonly="readonly"
                      />
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>SUMMARY PROJECTION</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.brokerPriceOpinionProjection_E78 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.brokerPriceOpinionProjection_F78 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.brokerPriceOpinionProjection_G78 | currency(0) }}</td>
                </tr>

              </table>

            </div>

          </div>
        </div>

        <!-- SPREADSHEET TRIAL 1 -->

      </div>

    </div>

    <p class="disclaimer">DISCLAIMER: This represents an estimated sale price for this property. It is not the same as the opinion of value in an appraisal developed by a licensed appraiser under the Uniform Standards of Professional Appraisal Practice. LS Realty Advisors, Inc., and/or Lifestyles Realty, Inc., and/or Lifestyles Unlimited, Inc. have not verified the information and make no guarantee, warranty, or representation. This broker price opinion was either filled out by a Lifestyles representative or the potential buyer or other. Further investigation may be necessary as more information is made available. When more information is available the opinion may substantially change; the reader should be aware of the limited scope of this opinion.</p>

    <b-modal
      :active.sync="$store.state.isRentCompsActive"
      has-modal-card
      :canCancel="[]"
    >
      <RentComps
        :propertyId="$route.params.property_id"
        :rents="$store.state.bpo.outputs.rents"
        :inputsRents="$store.state.bpo.inputs.rents"
      />
    </b-modal>

    <b-modal
      :active.sync="$store.state.isShareEvaluationActive"
      has-modal-card
      :canCancel="[]"
    >
      <ShareEvaluation />
    </b-modal>

  </div>

</template>

<script>
import BpoCalculatedResults from "@/components/properties/evaluations/multifamily/BPOCalculatedResults.vue";
import Financial from "formulajs";
import Moment from "moment";
import { VueEditor } from "vue2-editor";
import RentComps from "@/components/properties/evaluations/multifamily/RentComps.vue";
import { uuid } from "vue-uuid";
import Pusher from "pusher-js";
import ShareEvaluation from "@/components/properties/evaluations/multifamily/ShareEvaluation.vue";
import SharedHeader from "@/components/properties/evaluations/multifamily/SharedHeader.vue";
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  components: {
    BpoCalculatedResults,
    Financial,
    Moment,
    VueEditor,
    RentComps,
    uuid,
    Pusher,
    ShareEvaluation,
    SharedHeader,
    VueAutonumeric
  },

  props: {
    property_id: undefined,
    bpo_id: undefined,
    guid: undefined
  },

  async mounted() {
    if (this.$route.params.guid != undefined) {
      this.$store.state.isLoginRequired = false;
      this.$store.state.session = undefined;
      let guid = this.$route.params.guid;
      let editKey = this.$route.params.editKey
        ? this.$route.params.editKey
        : "";
      await this.createSharedSession(guid, editKey);
      if (this.$store.state.session) {
        this.$store.state.session.user.password = "";
        this.shared = true;
        this.$store.state.isLoginRequired = false;
        if (!editKey) this.readonly = true;
      } else return;
    }

    console.log(
      "mounted()",
      this.$route.params.property_id,
      this.$route.params.bpo_id
    );
    var propertyId = this.$route.params.property_id;
    var bpoId = this.$route.params.bpo_id;
    this.$store.dispatch("getProperty", propertyId);
    await this.$store.dispatch("getBPO", { propertyId, bpoId });

    this.subscribe();

    this.keyPressed = false;
  },

  created() {
    window.addEventListener(
      "keydown",
      async () => {
        await this.setKeyPressed();
      },
      true
    );
    window.addEventListener(
      "click",
      async () => {
        await this.setKeyPressed();
      },
      true
    );
  },

  beforeDestroy() {
    this.unsubscribe();
    if (this.shared) this.$store.state.session = undefined;
  },

  data() {
    return {
      inputBackgroundColor: "#FFDD57",
      showHelpDealInputs: false,
      rentModal: false,
      lastCalculateRequest: new Moment(),
      customToolbar: [["bold", "italic", "underline"]],
      showExpenseGuidelines: false,
      okToPublish: true,
      pusher: [],
      instanceGuid: uuid.v1(),
      packets: [],
      shared: false,
      readonly: false,
      keyPressed: false,
      decimal: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      },
      number: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      },
      currency: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "$",
        currencySymbolPlacement: "p",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      },
      percentage: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "%",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      },
      years: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: " years",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      }
    };
  },

  methods: {
    showRentRangeComps() {
      this.$store.state.rentCompPropertyId = null;
      this.$store.state.rentComps = [];
      this.$store.state.isRentCompsActive = true;
    },

    shareEvaluation(evaluation) {
      console.log("shareEvaluation()", evaluation);
      this.$store.commit("UPDATE_EVALUATION", evaluation);
      this.$store.state.isShareEvaluationActive = true;
    },

    async setKeyPressed() {
      this.keyPressed = true;
    },

    async createSharedSession(guid, editKey) {
      await this.$store
        .dispatch("createSharedSession", { guid, editKey })
        .then(() => {}, () => {});
    },

    subscribe() {
      this.pusher = new Pusher("84c708ec29b0f3de7a16", {
        cluster: "mt1"
      });
      this.pusher.subscribe(this.$store.state.bpo.id);
      this.pusher.bind("bpo_field_update", data => {
        this.setFieldValue(
          data.bpo,
          data.field,
          data.instanceGuid,
          data.timeStamp
        );
      });
    },

    unsubscribe() {
      this.pusher.unsubscribe(this.$store.state.bpo.id);
    },

    setFieldValue(bpo, field, instanceGuid, timeStamp) {
      console.log("setFieldValue()", field, instanceGuid, timeStamp);
      if (this.instanceGuid != instanceGuid) {
        // Make sure this is the latest publish from this instanceGuid.
        if (this.isLatestPublish(instanceGuid, timeStamp)) {
          console.log(`updating ${field}`);

          // Don't publish when this value gets updated!
          console.log("setting okToPublish=false");
          this.okToPublish = false;

          // Update the field to the value passed in the bpo.
          let code = "this.$store.state.bpo." + field + " = bpo." + field;
          eval(code);
        } else console.log("NOT UPDATED!");
      }
    },

    isLatestPublish(instanceGuid, timeStamp) {
      let latestPublish = this.packets.find(
        publish => publish.instanceGuid === instanceGuid
      );
      if (latestPublish == undefined) {
        // First packet we've received from this instance, so save it and return true.
        let packet = { instanceGuid, timeStamp };
        this.packets.push(packet);
        return true;
      } else {
        // If this timeStamp is older than the last one we got, don't do anything.
        if (timeStamp < latestPublish.timeStamp) return false;

        // This timeStamp is newer so replace it in the packets list and return true.
        this.packets.splice(
          this.packets.findIndex(item => item.instanceGuid === instanceGuid),
          1
        );

        let packet = { instanceGuid, timeStamp };
        this.packets.push(packet);
        return true;
      }
    },

    async calculate(field = "", delay = true) {
      let interval = 500;
      this.lastCalculateRequest = new Moment();

      // Publish these changes if there is a field and it's ok to publish.
      if (this.okToPublish && this.keyPressed) {
        if (field) {
          console.log("publishing change", field, instanceGuid);
          var propertyId = this.$route.params.property_id;
          var bpoId = this.$route.params.bpo_id;
          var bpo = this.$store.state.bpo;
          let instanceGuid = this.instanceGuid;
          let timeStamp = this.lastCalculateRequest.toISOString();
          this.$store
            .dispatch("bpoPublishField", {
              propertyId,
              bpoId,
              bpo,
              field,
              instanceGuid,
              timeStamp
            })
            .then(() => {})
            .catch(() => {});
        }
      } else {
        // It's now okay to publish again if more than 2 seconds have passed
        // since the page was mounted. This avoids calling Pusher for every
        // field on the page on the initial load.
        if (this.keyPressed == true) {
          console.log("setting okToPublish=true");
          this.okToPublish = true;
        }
      }
      // Queue up the calculation.
      if (delay) {
        setTimeout(() => {
          let now = new Moment();
          let lastCalc = this.lastCalculateRequest;
          let diff = now - lastCalc;
          if (diff >= interval) {
            this.doCalculations(this.$store.state.bpo);

            // Persist to the document store.
            this.updateBpo();
          }
        }, interval);
      } else this.doCalculations(this.$store.state.bpo);
    },

    async updateBpo() {
      var propertyId = this.$route.params.property_id;
      var bpoId = this.$route.params.bpo_id;
      var bpo = this.$store.state.bpo;
      await this.$store
        .dispatch("updateBpo", {
          propertyId,
          bpoId,
          bpo
        })
        .then(() => {})
        .catch(() => {});
    },

    addLine() {
      let checkEmptyLines = this.$store.state.bpo.inputs.rents.filter(
        line => line.unitCount === null
      );
      if (
        checkEmptyLines.length >= 1 &&
        this.$store.state.bpo.inputs.rents.length > 0
      ) {
        this.calculate("inputs.rents");
        return;
      }
      this.$store.state.bpo.inputs.rents.push({
        type: null,
        unitCount: null,
        sqft: null,
        currentRent: null,
        proformaRent: null
      });
      this.calculate("inputs.rents");
    },

    async removeLine(lineId) {
      await this.calculate("inputs.rents");
      if (!this.blockRemoval) {
        this.$store.state.bpo.inputs.rents.splice(lineId, 1);
        await this.calculate("inputs.rents");
      }
    },

    updateRentIncreasePercent() {
      for (var rentRow of this.$store.state.bpo.inputs.rents) {
        rentRow.proformaRent = this.updateProformaRent(rentRow.currentRent);
      }
      this.calculate("inputs.rents");
    },

    updateProformaRent(currentRent) {
      var currentRentInt = parseInt(currentRent);
      var increasePercent = parseFloat(
        this.$store.state.bpo.inputs.proformas.rentIncreasePercent_O26 / 100
      );
      // Calculate the proformaRent.
      var ret = Math.round(currentRentInt + currentRentInt * increasePercent);
      this.calculate("inputs.rents");
      return ret;
    },

    goToProperty() {
      this.$router.push({
        name: "PropertyDetails",
        params: {
          property_id: this.$store.state.property.id
        }
      });
    },

    getValue(input) {
      if (parseFloat(input)) return input;
      else return 0;
    },

    getOfferPriceTargetNetRoi(targetNetROI) {
      let high = 1000000000;
      let low = 0;
      let tolerance = 0.001;
      let top = targetNetROI + tolerance;
      let bottom = targetNetROI - tolerance;
      for (var index = 0; index < 100; index++) {
        let test = low + (high - low) / 2;

        // Make a copy of the bpo.
        let bpo = JSON.parse(JSON.stringify(this.$store.state.bpo));

        // Set the inputs.
        bpo.inputs.offerPriceCalcType = "Raw";
        bpo.inputs.offerPrice_E18 = test;

        // Do the calc and look at the result.
        this.doCalculations(bpo);
        let netROI = bpo.outputs.proformas.netROICashOnCash_G70;

        // Adjust the inputs and try again if needed.
        if (netROI > top) low = test;
        else if (netROI < bottom || isNaN(netROI)) high = test;
        else return test;
      }

      return 0;
    },

    getOfferPriceTargetDSCR(targetDSCR) {
      let high = 1000000000;
      let low = 0;
      let tolerance = 0.001;
      let top = targetDSCR + tolerance;
      let bottom = targetDSCR - tolerance;
      for (var index = 0; index < 100; index++) {
        let test = low + (high - low) / 2;

        // Make a copy of the bpo2.
        let bpo = JSON.parse(JSON.stringify(this.$store.state.bpo));

        // Set the inputs.
        bpo.inputs.offerPriceCalcType = "Raw";
        bpo.inputs.offerPrice_E18 = test;

        // Do the calc and look at the result.
        this.doCalculations(bpo);
        let dscr = bpo.outputs.proformas.debtServiceCoverageRatio_G66;

        // Adjust the inputs and try again if needed.
        if (dscr > top) low = test;
        else if (dscr < bottom) high = test;
        else return test;
      }

      return 0;
    },

    // DO CALCULATIONS
    async doCalculations(bpo) {
      let inputs = bpo.inputs;
      let outputs = bpo.outputs;

      for (var index = 0; index < 5; index++) {
        // Rent Grids.
        outputs.rents = [];
        inputs.rents.forEach(row => {
          if (!row.type) row.type = "";
          row.unitCount = parseInt(this.getValue(row.unitCount));
          row.sqft = parseInt(this.getValue(row.sqft));
          row.currentRent = parseInt(this.getValue(row.currentRent));
          row.proformaRent = parseInt(this.getValue(row.proformaRent));

          let newRow = {};
          newRow.type = row.type;
          newRow.unitCount = row.unitCount;
          newRow.sqft = row.sqft;
          newRow.currentRent = row.currentRent;
          newRow.currentPricePerSqft =
            row.sqft == 0 ? 0 : row.currentRent / row.sqft;
          newRow.currentMonthly = row.currentRent * row.unitCount;
          newRow.currentAnnual = row.currentRent * row.unitCount * 12;
          newRow.proformaRent = row.proformaRent;
          newRow.proformaPricePerSqft =
            row.sqft == 0 ? 0 : row.proformaRent / row.sqft;
          newRow.proformaMonthly = row.proformaRent * row.unitCount;
          newRow.proformaAnnual = row.proformaRent * row.unitCount * 12;

          outputs.rents.push(newRow);
        });

        outputs.totalUnitCount_J19 = outputs.rents
          .map(rent => rent.unitCount)
          .reduce((a, b) => a + b, 0);
        outputs.totalCurrentRent_K19 =
          outputs.totalUnitCount_J19 == 0
            ? 0
            : outputs.totalCurrentMonthly_N19 / outputs.totalUnitCount_J19;
        outputs.totalSqft_L19 = outputs.rents
          .map(rent => rent.sqft * rent.unitCount)
          .reduce((a, b) => a + b, 0);
        outputs.totalCurrentPricePerSqft_M19 =
          outputs.totalSqft_L19 == 0
            ? 0
            : outputs.totalCurrentMonthly_N19 / outputs.totalSqft_L19;
        outputs.totalCurrentMonthly_N19 = outputs.rents.reduce(
          (acc, currValue) => acc + currValue.currentMonthly,
          0
        );
        outputs.totalCurrentAnnual_O19 = outputs.rents.reduce(
          (acc, currValue) => acc + currValue.currentAnnual,
          0
        );

        // PROFORMA RENT GRID CALCULATIONS.
        outputs.totalProformaRent_K37 =
          outputs.totalUnitCount_J19 == 0
            ? 0
            : outputs.totalProformaMonthly_N37 / outputs.totalUnitCount_J19;
        outputs.totalProformaPricePerSqft_M37 =
          outputs.totalSqft_L19 == 0
            ? 0
            : outputs.totalProformaMonthly_N37 / outputs.totalSqft_L19;
        outputs.totalProformaMonthly_N37 = outputs.rents.reduce(
          (acc, currValue) => acc + currValue.proformaMonthly,
          0
        );
        outputs.totalProformaAnnual_O37 = outputs.rents.reduce(
          (acc, currValue) => acc + currValue.proformaAnnual,
          0
        );

        // OUTPUTS.
        outputs.askingPrice_E17 = parseFloat(inputs.askingPrice_E17);
        if (outputs.numberOfUnits_E26 != 0)
          outputs.askingPricePerUnit_F17 =
            outputs.askingPrice_E17 / outputs.numberOfUnits_E26;
        else outputs.askingPricePerUnit_F17 = 0;
        if (inputs.offerPriceCalcType == "Raw")
          outputs.offerPrice_E18 = parseInt(inputs.offerPrice_E18);
        else if (inputs.offerPriceCalcType == "CapRate") {
          if (inputs.offerPriceCapRate != 0)
            outputs.offerPrice_E18 = parseInt(
              outputs.actuals.netOperatingIncome_E53 /
                (inputs.offerPriceCapRate / 100)
            );
          else outputs.offerPrice_E18 = 0;
        } else if (inputs.offerPriceCalcType == "Dscr")
          outputs.offerPrice_E18 = this.getOfferPriceTargetDSCR(
            inputs.offerPriceTargetDebtServiceCoverageRatio
          );
        else if (inputs.offerPriceCalcType == "NetRoi")
          outputs.offerPrice_E18 = this.getOfferPriceTargetNetRoi(
            inputs.offerPriceTargetNetReturnOnInvestment
          );
        else outputs.offerPrice_E18 = 0;
        if (outputs.numberOfUnits_E26 != 0)
          outputs.offerPricePerUnit_F18 =
            outputs.offerPrice_E18 / outputs.numberOfUnits_E26;
        else outputs.offerPricePerUnit_F18 = 0;
        outputs.rehabInLoan_E19 =
          outputs.totalRehab_E33 *
          (inputs.percentOfRehabToBeFinanced_E34 / 100);
        if (outputs.numberOfUnits_E26 != 0)
          outputs.rehabInLoanPerUnit_F19 =
            outputs.rehabInLoan_E19 / outputs.numberOfUnits_E26;
        else outputs.rehabInLoanPerUnit_F19 = 0;
        outputs.totalIn_E20 = outputs.offerPrice_E18 + outputs.rehabInLoan_E19;
        outputs.closingCost_E21 =
          outputs.totalIn_E20 * (inputs.closingCostPercent_D21 / 100);
        if (inputs.operatingCapitalCalcType == "Raw")
          outputs.operatingCapital_E22 = parseFloat(
            inputs.operatingCapital_E22
          );
        else if (outputs.proformas.totalExpenses_G51 != 0)
          outputs.operatingCapital_E22 =
            ((outputs.annualDebtService_E32 +
              outputs.proformas.totalExpenses_G51) /
              12) *
            2;
        else outputs.operatingCapital_E22 = 0;
        if (inputs.totalRehabCalcType == "Raw")
          outputs.totalRehab_E33 = parseFloat(inputs.totalRehab_E33);
        else
          outputs.totalRehab_E33 =
            inputs.totalRehabUnitFactor * outputs.totalUnitCount_J19;
        outputs.rehabNotInLoan_E23 =
          outputs.totalRehab_E33 - outputs.rehabInLoan_E19;
        outputs.totalOutOfPocket_E24 =
          outputs.closingCost_E21 +
          outputs.operatingCapital_E22 +
          outputs.rehabNotInLoan_E23 +
          outputs.downPayment_F28;
        outputs.numberOfUnits_E26 = parseInt(
          outputs.rents.reduce((a, b) => a + b.unitCount, 0)
        );
        if (outputs.numberOfUnits_E26 != 0)
          outputs.totalInPricePerUnit_E27 =
            outputs.totalIn_E20 / outputs.numberOfUnits_E26;
        else outputs.totalInPricePerUnit_E27 = 0;
        outputs.downPayment_F28 =
          (inputs.downPaymentPercent_E28 / 100) * outputs.totalIn_E20;
        outputs.loanAmount_E29 = outputs.totalIn_E20 - outputs.downPayment_F28;
        outputs.interestOnly = inputs.interestOnly;
        outputs.annualDebtService_E32 =
          outputs.actuals.mortgageInterest_E55 +
          outputs.actuals.principalReduction_E64;
        outputs.notes_I45 = inputs.notes_I45;

        // ACTUALS.
        outputs.actuals.label_E36 = inputs.actuals.label_E36;
        if (inputs.actuals.grossRentalIncomeCalcType == "Raw")
          outputs.actuals.grossRentalIncome_E38 = parseFloat(
            inputs.actuals.grossRentalIncome_E38
          );
        else
          outputs.actuals.grossRentalIncome_E38 = outputs.rents.reduce(
            (a, b) => a + b.currentAnnual,
            0
          );
        outputs.actuals.economicVacancy_E39 =
          outputs.actuals.grossRentalIncome_E38 *
          (outputs.actuals.economicVacancyRate_K41 / 100);
        if (inputs.actuals.economicVacanycRateCalcType == "Raw")
          outputs.actuals.economicVacancyRate_K41 = parseFloat(
            inputs.actuals.economicVacancyRate_K41
          );
        else if (outputs.actuals.grossRentalIncome_E38 != 0)
          outputs.actuals.economicVacancyRate_K41 =
            (1 -
              inputs.actuals.effectiveRentalIncome /
                outputs.actuals.grossRentalIncome_E38) *
            100;
        else outputs.actuals.economicVacancyRate_K41 = 0;
        outputs.actuals.netRentalIncome_E40 =
          outputs.actuals.grossRentalIncome_E38 -
          outputs.actuals.economicVacancy_E39;
        outputs.actuals.laundry_E42 = parseFloat(inputs.actuals.laundry_E42);
        outputs.actuals.rubs = parseFloat(inputs.actuals.rubs);
        outputs.actuals.miscellaneousOtherIncome_E43 = parseFloat(
          inputs.actuals.miscellaneousOtherIncome_E43
        );
        outputs.actuals.totalNetIncome_E45 =
          outputs.actuals.netRentalIncome_E40 +
          outputs.actuals.laundry_E42 +
          outputs.actuals.rubs +
          outputs.actuals.miscellaneousOtherIncome_E43;
        if (inputs.actuals.expensesPerUnitCalcType == "Raw")
          outputs.actuals.expensesPerUnit_E47 = parseFloat(
            inputs.actuals.expensesPerUnit_E47
          );
        else if (outputs.totalUnitCount_J19 != 0)
          outputs.actuals.expensesPerUnit_E47 =
            inputs.actuals.t12OperatingExpenses / outputs.totalUnitCount_J19;
        else outputs.actuals.expensesPerUnit_E47 = 0;
        outputs.totalSqft_L19 = outputs.rents
          .map(rent => rent.sqft * rent.unitCount)
          .reduce((a, b) => a + b, 0);

        if (
          outputs.rents
            .map(rent => rent.sqft * rent.unitCount)
            .reduce((a, b) => a + b, 0) != 0
        )
          outputs.actuals.ExpensesPerSqft_E48 =
            outputs.actuals.totalExpenses_E51 / outputs.totalSqft_L19;
        else outputs.actuals.expensesPerSqft_E48 = 0;
        if (outputs.actuals.totalNetIncome_E45 != 0)
          outputs.actuals.expensesAsPercentOfIncome_E49 =
            (outputs.actuals.totalExpenses_E51 /
              outputs.actuals.totalNetIncome_E45) *
            100;
        else outputs.actuals.expensesAsPercentOfIncome_E49 = 0;
        outputs.actuals.totalExpenses_E51 =
          outputs.numberOfUnits_E26 * outputs.actuals.expensesPerUnit_E47;
        outputs.actuals.netOperatingIncome_E53 =
          outputs.actuals.totalNetIncome_E45 -
          outputs.actuals.totalExpenses_E51;
        if (outputs.loanAmount_E29 != 0 && outputs.loanAmount_E29 > 0)
          if (inputs.interestOnly) {
            outputs.actuals.mortgageInterest_E55 =
              (outputs.loanAmount_E29 * inputs.interestRatePercent_E30) / 100;
          } else {
            outputs.actuals.mortgageInterest_E55 =
              Financial.CUMIPMT(
                inputs.interestRatePercent_E30 / 100 / 12,
                inputs.termInYears_E31 * 12,
                outputs.loanAmount_E29,
                1,
                12,
                0
              ) * -1;
          }
        else outputs.actuals.mortgageInterest_E55 = 0;
        if (!outputs.actuals.mortgageInterest_E55)
          outputs.actuals.mortgageInterest_E55 = 0;
        outputs.actuals.capitalReservesPerUnit_E57 = parseFloat(
          inputs.actuals.capitalReservesPerUnit_E57
        );
        outputs.actuals.capitalReserves_E58 =
          outputs.numberOfUnits_E26 *
          outputs.actuals.capitalReservesPerUnit_E57;
        outputs.actuals.preTaxProfit_E60 =
          outputs.actuals.netOperatingIncome_E53 -
          outputs.actuals.mortgageInterest_E55 -
          outputs.actuals.capitalReserves_E58;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.actuals.preTaxROI_E61 =
            (outputs.actuals.preTaxProfit_E60 / outputs.totalOutOfPocket_E24) *
            100;
        else outputs.actuals.preTaxROI_E61 = 0;
        if (
          outputs.loanAmount_E29 != 0 &&
          outputs.loanAmount_E29 > 0 &&
          !inputs.interestOnly
        )
          outputs.actuals.principalReduction_E64 =
            Financial.CUMPRINC(
              inputs.interestRatePercent_E30 / 100 / 12,
              inputs.termInYears_E31 * 12,
              outputs.loanAmount_E29,
              1,
              12,
              0
            ) * -1;
        else outputs.actuals.principalReduction_E64 = 0;
        if (!outputs.actuals.principalReduction_E64)
          outputs.actuals.principalReduction_E64 = 0;
        outputs.actuals.debtService_E65 =
          outputs.actuals.principalReduction_E64 +
          outputs.actuals.mortgageInterest_E55;
        if (outputs.annualDebtService_E32 != 0)
          outputs.actuals.debtServiceCoverageRatio_E66 =
            (outputs.actuals.netOperatingIncome_E53 -
              outputs.actuals.capitalReserves_E58) /
            outputs.annualDebtService_E32;
        outputs.actuals.netCashflowAnnual_E68 =
          outputs.actuals.preTaxProfit_E60 -
          outputs.actuals.principalReduction_E64;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.actuals.netROICashOnCash_E70 =
            (outputs.actuals.netCashflowAnnual_E68 /
              outputs.totalOutOfPocket_E24) *
            100;
        else outputs.actuals.netROICashOnCash_E70 = 0;
        if (outputs.offerPrice_E18 != 0)
          outputs.actuals.capRateProjection_E76 =
            (outputs.actuals.netOperatingIncome_E53 / outputs.offerPrice_E18) *
            100;
        else outputs.actuals.capRateProjection_E76 = 0;
        if (outputs.actuals.capRateProjection_E76 > 0)
          outputs.actuals.brokerPriceOpinionProjection_E78 =
            outputs.actuals.netOperatingIncome_E53 /
            (outputs.actuals.capRateProjection_E76 / 100);
        else outputs.actuals.brokerPriceOpinionProjection_E78 = 0;

        // Brokers.
        outputs.brokers.label_F36 = inputs.brokers.label_F36;
        outputs.brokers.grossRentalIncome_F38 = parseFloat(
          inputs.brokers.grossRentalIncome_F38
        );
        outputs.brokers.economicVacancy_F39 =
          outputs.brokers.grossRentalIncome_F38 *
          (inputs.brokers.economicVacancyRate_K42 / 100);
        outputs.brokers.netRentalIncome_F40 =
          outputs.brokers.grossRentalIncome_F38 -
          outputs.brokers.economicVacancy_F39;
        outputs.brokers.laundry_F42 = parseFloat(inputs.brokers.laundry_F42);
        outputs.brokers.rubs = parseFloat(inputs.brokers.rubs);
        outputs.brokers.miscellaneousOtherIncome_F43 = parseFloat(
          inputs.brokers.miscellaneousOtherIncome_F43
        );
        outputs.brokers.totalNetIncome_F45 =
          outputs.brokers.netRentalIncome_F40 +
          outputs.brokers.laundry_F42 +
          outputs.brokers.rubs +
          outputs.brokers.miscellaneousOtherIncome_F43;
        outputs.brokers.expensesPerUnit_F47 = parseFloat(
          inputs.brokers.expensesPerUnit_F47
        );
        if (
          outputs.rents
            .map(rent => rent.sqft * rent.unitCount)
            .reduce((a, b) => a + b, 0) != 0
        )
          outputs.brokers.expensesPerSqft_F48 =
            outputs.brokers.totalExpenses_F51 / outputs.totalSqft_L19;
        else outputs.brokers.expensesPerSqft_F48 = 0;
        if (outputs.brokers.totalNetIncome_F45 != 0)
          outputs.brokers.expensesAsPercentOfIncome_F49 =
            (outputs.brokers.totalExpenses_F51 /
              outputs.brokers.totalNetIncome_F45) *
            100;
        else outputs.brokers.expensesAsPercentOfIncome_F49 = 0;
        outputs.brokers.totalExpenses_F51 =
          outputs.numberOfUnits_E26 * outputs.brokers.expensesPerUnit_F47;
        outputs.brokers.netOperatingIncome_F53 =
          outputs.brokers.totalNetIncome_F45 -
          outputs.brokers.totalExpenses_F51;
        outputs.brokers.mortgageInterest_F55 =
          outputs.actuals.mortgageInterest_E55;
        outputs.brokers.capitalReservesPerUnit_F57 = parseFloat(
          inputs.brokers.capitalReservesPerUnit_F57
        );
        outputs.brokers.capitalReserves_F58 =
          outputs.numberOfUnits_E26 *
          outputs.brokers.capitalReservesPerUnit_F57;
        outputs.brokers.preTaxProfit_F60 =
          outputs.brokers.netOperatingIncome_F53 -
          outputs.brokers.mortgageInterest_F55 -
          outputs.brokers.capitalReserves_F58;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.brokers.preTaxROI_F61 =
            (outputs.brokers.preTaxProfit_F60 / outputs.totalOutOfPocket_E24) *
            100;
        else outputs.brokers.preTaxROI_F61 = 0;
        outputs.brokers.assetManagement_F63 =
          outputs.brokers.totalNetIncome_F45 *
          (inputs.assetManagementPercent_D63 / 100);
        outputs.brokers.principalReduction_F64 =
          outputs.actuals.principalReduction_E64;
        if (!outputs.brokers.principalReduction_F64)
          outputs.brokers.principalReduction_F64 = 0;
        outputs.brokers.debtService_F65 =
          outputs.brokers.principalReduction_F64 +
          outputs.brokers.mortgageInterest_F55;
        if (outputs.annualDebtService_E32 != 0)
          outputs.brokers.debtServiceCoverageRatio_F66 =
            (outputs.brokers.netOperatingIncome_F53 -
              outputs.brokers.capitalReserves_F58) /
            outputs.annualDebtService_E32;
        outputs.brokers.netCashflowAnnual_F68 =
          outputs.brokers.preTaxProfit_F60 -
          outputs.brokers.principalReduction_F64 -
          outputs.brokers.assetManagement_F63;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.brokers.netROICashOnCash_F70 =
            (outputs.brokers.netCashflowAnnual_F68 /
              outputs.totalOutOfPocket_E24) *
            100;
        else outputs.brokers.netROICashOnCash_F70 = 0;
        outputs.brokers.leadInvestorCompensation_F72 =
          outputs.brokers.netCashflowAnnual_F68 *
          (inputs.leadInvestorCompensationPercent_D72 / 100);
        outputs.brokers.netToPassives_F73 =
          outputs.brokers.netCashflowAnnual_F68 -
          outputs.brokers.leadInvestorCompensation_F72;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.brokers.netROIToPassives_F74 =
            (outputs.brokers.netToPassives_F73 / outputs.totalOutOfPocket_E24) *
            100;
        else outputs.brokers.netROIToPassives_F74 = 0;
        outputs.brokers.capRateProjection_F76 = parseFloat(
          inputs.brokers.capRateProjection_F76
        );
        if (outputs.brokers.capRateProjection_F76 > 0)
          outputs.brokers.brokerPriceOpinionProjection_F78 =
            outputs.brokers.netOperatingIncome_F53 /
            (outputs.brokers.capRateProjection_F76 / 100);
        else outputs.brokers.brokerPriceOpinionProjection_F78 = 0;

        // PROFORMAS.
        if (inputs.proformas.grossRentalIncomeCalcType == "Raw")
          outputs.proformas.grossRentalIncome_G38 = parseFloat(
            inputs.proformas.grossRentalIncome_G38
          );
        else
          outputs.proformas.grossRentalIncome_G38 = outputs.rents.reduce(
            (a, b) => a + b.proformaAnnual,
            0
          );
        outputs.proformas.economicVacancy_G39 =
          outputs.proformas.grossRentalIncome_G38 *
          (inputs.proformas.economicVacancyRate_K43 / 100);
        outputs.proformas.netRentalIncome_G40 =
          outputs.proformas.grossRentalIncome_G38 -
          outputs.proformas.economicVacancy_G39;
        outputs.proformas.laundry_G42 = parseFloat(
          inputs.proformas.laundry_G42
        );
        outputs.proformas.rubs = parseFloat(inputs.proformas.rubs);
        outputs.proformas.miscellaneousOtherIncome_G43 = parseFloat(
          inputs.proformas.miscellaneousOtherIncome_G43
        );
        outputs.proformas.totalNetIncome_G45 =
          outputs.proformas.netRentalIncome_G40 +
          outputs.proformas.laundry_G42 +
          outputs.proformas.rubs +
          outputs.proformas.miscellaneousOtherIncome_G43;
        outputs.proformas.expensesPerUnit_G47 = parseFloat(
          inputs.proformas.expensesPerUnit_G47
        );
        if (
          outputs.rents
            .map(rent => rent.sqft * rent.unitCount)
            .reduce((a, b) => a + b, 0) != 0
        )
          outputs.proformas.expensesPerSqft_G48 =
            outputs.proformas.totalExpenses_G51 / outputs.totalSqft_L19;
        if (outputs.proformas.totalNetIncome_G45 != 0)
          outputs.proformas.expensesAsPercentOfIncome_G49 =
            (outputs.proformas.totalExpenses_G51 /
              outputs.proformas.totalNetIncome_G45) *
            100;
        else outputs.proformas.expensesAsPercentOfIncome_G49 = 0;
        outputs.proformas.totalExpenses_G51 =
          outputs.numberOfUnits_E26 * outputs.proformas.expensesPerUnit_G47;
        outputs.proformas.netOperatingIncome_G53 =
          outputs.proformas.totalNetIncome_G45 -
          outputs.proformas.totalExpenses_G51;
        outputs.proformas.mortgageInterest_G55 =
          outputs.actuals.mortgageInterest_E55;
        outputs.proformas.capitalReservesPerUnit_G57 = parseFloat(
          inputs.proformas.capitalReservesPerUnit_G57
        );
        outputs.proformas.capitalReserves_G58 =
          outputs.numberOfUnits_E26 *
          outputs.proformas.capitalReservesPerUnit_G57;
        outputs.proformas.preTaxProfit_G60 =
          outputs.proformas.netOperatingIncome_G53 -
          outputs.proformas.mortgageInterest_G55 -
          outputs.proformas.capitalReserves_G58;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.proformas.preTaxROI_G61 =
            (outputs.proformas.preTaxProfit_G60 /
              outputs.totalOutOfPocket_E24) *
            100;
        else outputs.proformas.preTaxROI_G61 = 0;
        outputs.proformas.assetManagement_G63 =
          outputs.proformas.totalNetIncome_G45 *
          (inputs.assetManagementPercent_D63 / 100);
        outputs.proformas.principalReduction_G64 =
          outputs.actuals.principalReduction_E64;
        outputs.proformas.debtService_G65 =
          outputs.proformas.principalReduction_G64 +
          outputs.proformas.mortgageInterest_G55;
        if (outputs.annualDebtService_E32 != 0)
          outputs.proformas.debtServiceCoverageRatio_G66 =
            (outputs.proformas.netOperatingIncome_G53 -
              outputs.proformas.capitalReserves_G58) /
            outputs.annualDebtService_E32;
        outputs.proformas.netCashflowAnnual_G68 =
          outputs.proformas.preTaxProfit_G60 -
          outputs.proformas.principalReduction_G64 -
          outputs.proformas.assetManagement_G63;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.proformas.netROICashOnCash_G70 =
            (outputs.proformas.netCashflowAnnual_G68 /
              outputs.totalOutOfPocket_E24) *
            100;
        else outputs.proformas.netROICashOnCash_G70 = 0;
        outputs.proformas.leadInvestorCompensation_G72 =
          outputs.proformas.netCashflowAnnual_G68 *
          (inputs.leadInvestorCompensationPercent_D72 / 100);
        outputs.proformas.netToPassives_G73 =
          outputs.proformas.netCashflowAnnual_G68 -
          outputs.proformas.leadInvestorCompensation_G72;
        if (outputs.totalOutOfPocket_E24 != 0)
          outputs.proformas.netROIToPassives_G74 =
            (outputs.proformas.netToPassives_G73 /
              outputs.totalOutOfPocket_E24) *
            100;
        else outputs.proformas.netROIToPassives_G74 = 0;
        outputs.proformas.capRateProjection_G76 = parseFloat(
          inputs.proformas.capRateProjection_G76
        );
        if (outputs.proformas.capRateProjection_G76 > 0)
          outputs.proformas.brokerPriceOpinionProjection_G78 =
            outputs.proformas.netOperatingIncome_G53 /
            (outputs.proformas.capRateProjection_G76 / 100);
        else outputs.proformas.brokerPriceOpinionProjection_G78 = 0;
      }
    }
    // DO CALCULATIONS
  }
};
</script>

<style>
table {
  font-size: 90%;
}
input[type="number"] {
  text-align: right;
}
input[type="text"] {
  text-align: left;
}
td.align-right {
  text-align: right;
}
div.align-right {
  text-align: right;
}
div.inputable {
  background-color: #ffffdd;
}
td.column-header {
  font-weight: bold;
  font-size: 120%;
}
tr.subtotal1 {
  font-weight: bold;
  font-size: 90%;
  border-top: 2px solid;
  border-bottom: 2px solid;
}
tr.subtotal2 {
  font-weight: bold;
  font-size: 110%;
  border-top: 2px solid;
  border-bottom: 2px solid;
}
tr.subtotal3 {
  font-weight: bold;
  outline: 2px solid;
  font-size: 120%;
}
.disclaimer {
  font-size: 80%;
  font-weight: bold;
}
.textarea {
  width: 250px;
  min-height: 50px;
  height: auto;
  border: 2px solid rgba(63, 63, 63, 1);
}
.calc-options {
  margin-left: 2em;
}
.notices .snackbar {
  min-height: 2.5em !important;
  min-width: 1em !important;
}
.flash-updated {
  -webkit-animation: flash-updated 2s ease 1;
  animation: flash-updated 2s ease 1;
}
@-webkit-keyframes flash-updated {
  10% {
    border-color: green;
    border-width: 1px;
    background-color: yellow;
  }
}
@keyframes flash-updated {
  10% {
    border-color: green;
    border-width: 1px;
    background-color: yellow;
  }
}
div.ql-editor {
  background-color: #ffdd57 !important;
}
</style>
